module.exports = __webpack_public_path__ + "static/media/Logo_Occitanie_2017.596b82f3.svg";